// api
import ModelService from '@/services/model.service'
import { mapState } from 'vuex'

export default {
  name: 'Testimonial',
  data() {
    return {
      // 英语 中文 越南语 柬埔寨语 印尼语
      adIdList: [8, 19, 46, 64, 81],
      // data
      curCompanyData: [],
      curPeopleData: {},
      curFactoryId: '',
      // 按照显示顺序
      curFactoryIndex: '0',
      popupStatus: false,
      acitveStatus: 0,
      bannerInfo: '',
      factoryList: '',
      peopleList: '',
      curYearList: [],
      yearSplitList: [],
      acitveYear: '',
      swiperOption: {
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: true,
      },
    };
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex'])
  }),
  watch: {
    LangIndex: {
      handler(str) {
        this.init();
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    init(){
      this.getBannerList();
      this.getFactoryList();
    },
    // 根据id获取广告图片
    getBannerList() {
      const param = {
        lang: this.language,
        adId: this.adIdList[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.bannerInfo = res.data[0];
        }
      });
    },
    // 获取工厂列表
    getFactoryList() {
      const language = {
        lang: this.language
      };
      ModelService.getFactoryList(language).then((res) => {
        if (res.code === 0) {
          this.factoryList = res.data;
          this.curFactoryId = res.data[this.curFactoryIndex].id;
          this.getFactoryEmployeeList();
          // console.log('getFactoryList: ', res.data);
        }
      });
    },
    // 获取员工列表
    getFactoryEmployeeList() {
      const language = {
        lang: this.language
      };
      ModelService.getFactoryEmployeeList(language).then((res) => {
        if (res.code === 0) {
          this.peopleList = res.data;
          this.curCompanyData = this.even(res.data);
          this.getYearList();
          // console.log('getFactoryEmployeeList: ', res.data);
        }
      });
    },
    // 清洗数据 获取年份数组
    getYearList() {
      let yearArr = [];
      const arr = this.curCompanyData;
      for(let item of arr) {
        const index = yearArr.indexOf(item.year);
        if(index < 0) {
          yearArr.push(item.year);
        }
      };
      yearArr.sort((a,b) => {
        return a - b
      }).reverse();
      
      if(yearArr.length > 0) {
        this.curYearList = yearArr;
        this.acitveYear = yearArr[0];
        this.yearSplitList = this.evenYear(yearArr[0]);
      } else {
        this.curYearList = [];
        this.yearSplitList = [];
      }
      // console.log(yearArr);
    },
    // 根据年份清洗员工数据
    evenYear(year) {
      const numbers = this.curCompanyData;
      return numbers.filter((number) => {
        return number.year === year
      })
    },
    // 数据过滤
    even(numbers) {
      return numbers.filter((number) => {
        return number.factoryId === this.curFactoryId && number.year
      })
    },
    // 切换工厂
    switchNav(index) {
      this.acitveStatus = index;
      this.curFactoryId = this.factoryList[index].id;
      this.curFactoryIndex = index;
      this.curCompanyData = this.even(this.peopleList);
      this.getYearList();
    },
    // 切换年份
    switchSecNav(item) {
      this.acitveYear = item;
      this.yearSplitList = this.evenYear(item);
    },
    openPeopleLayer(index) {
      this.popupStatus = true;
      this.curPeopleData = this.yearSplitList[index];
    },
    closePopup() {
      this.popupStatus = false;
    }
  },
};
